<template>
  <div :class="[$style.config, $style.card]">
    <template v-if="data?.fields?.renderAs">
      <div :class="$style.cardHeaderContainer">
        <h6 :class="$style.cardHeader">{{ data?.fields?.cardHeader }}</h6>
      </div>

      <div :class="$style.inner">
        <div :class="$style.media">
          <BasePicture
            v-if="data?.fields?.backgroundImage?.fields?.file?.url"
            :src="`${data?.fields?.backgroundImage?.fields?.file?.url}?w=336&h=300&q=70`"
            alt=""
            aria-hidden="true"
          />
        </div>

        <component
          :is="computedComponent[data?.fields?.renderAs]"
          :data="data"
        />
      </div>
    </template>

    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import CardRelatedArticles from './CardRelatedArticles.vue'
import CardChecklist from './CardChecklist.vue'
import CardEvent from './CardEvent.vue'
import CardSimple from './CardSimple.vue'
import CardVideo from './CardVideo.vue'

import type { TypeAsideCardWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeAsideCardWithoutUnresolvableLinksResponse
}>()

const computedComponent = computed(() => {
  return {
    Articles: CardRelatedArticles,
    Checklist: CardChecklist,
    Event: CardEvent,
    Simple: CardSimple,
    Video: CardVideo,
  }
})
</script>

<style lang="scss" module>
.config {
  --indigo: #252545;
}

.card {
  color: var(--white);
  max-width: 336px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 0;
}

.cardHeaderContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--indigo);
  font-family: var(--roboto-condensed);
  font-size: to-rem(20px);
  line-height: math.div(26, 20);
  padding: 10px;

  @include media('sm') {
    font-size: to-rem(23px);
    line-height: math.div(27, 23);
  }
}

.cardHeader {
  font-size: inherit;
}

.inner {
  position: relative;
  background-color: var(--black);
}

.media {
  position: relative;

  &:after {
    background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 50%
    );
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
